/* AlpenThermo világtérkép - d3 + world-atlas, képernyő-alapú fürtözéssel */
(function () {
  'use strict';
  /* saját, kicsinyített könyvtár (d3 részhalmaz + topojson) és egyszerűsített világtérkép a téma CDN-jéről */
  var loading = null;
  function script(src) {
    return new Promise(function (res, rej) {
      if (window.d3 && window.topojson) return res();
      var s = document.createElement('script'); s.src = src; s.async = true; s.onload = res; s.onerror = rej; document.head.appendChild(s);
    });
  }
  function libs(root) {
    if (!loading) loading = script(root.dataset.libs)
      .then(function () { return fetch(root.dataset.atlas).then(function (r) { return r.json(); }); });
    return loading;
  }

  function init(root) {
    if (root.dataset.atInit) return; root.dataset.atInit = 1;
    var data; try { data = JSON.parse(root.querySelector('[data-at-wdata]').textContent); } catch (e) { return; }
    var P = data.places.filter(function (p) { return isFinite(p.lat) && isFinite(p.lon); });
    P.forEach(function (p, i) { p.i = i; });
    var wrap = root.querySelector('.at-wmapwrap'), host = root.querySelector('.at-wmap');
    var card = root.querySelector('.at-wcard'), chipsEl = root.querySelector('.at-wchips');
    var group = 'all', T = { k: 1, x: 0, y: 0 }, active = null;

    /* statisztika */
    var uniq = function (k) { var o = {}; P.forEach(function (p) { if (p[k]) o[p[k]] = 1; }); return Object.keys(o).length; };
    var st = root.querySelectorAll('[data-at-wstat]');
    st.forEach(function (el) { var k = el.dataset.atWstat; el.textContent = k === 'places' ? P.length : uniq(k); });

    /* chipek */
    P.forEach(function (p) {
      var b = document.createElement('button'); b.type = 'button'; b.dataset.i = p.i; b.innerHTML = '<i></i>';
      b.appendChild(document.createTextNode(p.title)); b.addEventListener('click', function () { focusPlace(p); });
      chipsEl.appendChild(b); p.chip = b;
    });

    /* kártya */
    var shade = document.createElement('div'); shade.className = 'at-wshade'; document.body.appendChild(shade);
    shade.addEventListener('click', function () { closeCard(); });
    function openCard(p) {
      active = p; shade.classList.add('is-on');
      setGallery(p);
      card.querySelector('.at-wcard__loc').textContent = '📍 ' + (p.loc || p.title);
      card.querySelector('h3').textContent = p.title;
      card.querySelector('p').textContent = p.text || '';
      var who = card.querySelector('.at-wcard__who'); who.textContent = p.who ? '📷 ' + p.who : ''; who.hidden = !p.who;
      card.classList.add('is-open');
      requestAnimationFrame(function () { sync(); });
      P.forEach(function (q) { q.chip.classList.toggle('is-on', q === p); });
      render();
    }

    /* képgaléria a kártyán: nyilak, pöttyök, húzás (érintés + egér), billentyűk */
    var ph = card.querySelector('.at-wcard__ph'), gal = card.querySelector('.at-wgal');
    var gPrev = card.querySelector('.at-wgal__arr--prev'), gNext = card.querySelector('.at-wgal__arr--next'), gDots = card.querySelector('.at-wgal__dots');
    var gi = 0, gImgs = [], gst;
    function ratio(r) { r = parseFloat(r) || 1.5; return Math.min(Math.max(r, 0.7), 1.78); }
    function setGallery(p) {
      gImgs = (p.imgs && p.imgs.length) ? p.imgs : (p.img ? [{ s: p.img, r: 1.6 }] : []);
      ph.hidden = !gImgs.length;
      gal.innerHTML = ''; gDots.innerHTML = '';
      gImgs.forEach(function (im, i) {
        var d = document.createElement('div'); d.className = 'at-wgal__s';
        var img = document.createElement('img'); img.alt = p.title + (gImgs.length > 1 ? ' (' + (i + 1) + '/' + gImgs.length + ')' : '');
        img.decoding = 'async'; img.draggable = false;
        if (i < 2) img.src = im.s; else img.dataset.src = im.s;
        d.appendChild(img); gal.appendChild(d);
        if (gImgs.length > 1 && gImgs.length <= 7) { var dot = document.createElement('i'); gDots.appendChild(dot); }
      });
      if (gImgs.length > 7) { var c = document.createElement('span'); gDots.appendChild(c); }
      card.classList.toggle('has-gal', gImgs.length > 1);
      gi = 0; gal.classList.add('is-jump'); gal.scrollLeft = 0; ph.classList.add('is-jump');
      sync();
      requestAnimationFrame(function () { gal.classList.remove('is-jump'); ph.classList.remove('is-jump'); });
    }
    function sync() {
      var im = gImgs[gi]; if (!im) return;
      var w = gal.clientWidth || ph.clientWidth || 440;
      ph.style.setProperty('--gh', Math.round(w / ratio(im.r)) + 'px');
      [gi - 1, gi + 1, gi + 2].forEach(function (j) { var s = gal.children[j], img = s && s.firstChild; if (img && img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); } });
      gPrev.disabled = gi === 0; gNext.disabled = gi >= gImgs.length - 1;
      [].forEach.call(gDots.children, function (d, j) { if (d.tagName === 'SPAN') d.textContent = (gi + 1) + ' / ' + gImgs.length; else d.classList.toggle('is-on', j === gi); });
    }
    function go(i, instant) {
      i = Math.max(0, Math.min(gImgs.length - 1, i)); gi = i; sync();
      gal.scrollTo({ left: i * gal.clientWidth, behavior: instant ? 'auto' : 'smooth' });
    }
    gPrev.addEventListener('click', function () { go(gi - 1); });
    gNext.addEventListener('click', function () { go(gi + 1); });
    gal.addEventListener('scroll', function () {
      clearTimeout(gst);
      gst = setTimeout(function () { if (drag) return; var i = Math.round(gal.scrollLeft / (gal.clientWidth || 1)); if (i !== gi) { gi = i; sync(); } }, 70);
    }, { passive: true });
    /* egérrel húzás (érintésnél a natív görgetés dolgozik) */
    var drag = null;
    gal.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || gImgs.length < 2 || e.button !== 0) return;
      drag = { x: e.clientX, sl: gal.scrollLeft, moved: false }; gal.classList.add('is-drag');
      try { gal.setPointerCapture(e.pointerId); } catch (err) {}
    });
    gal.addEventListener('pointermove', function (e) {
      if (!drag) return; var dx = e.clientX - drag.x; if (Math.abs(dx) > 3) drag.moved = true;
      gal.scrollLeft = drag.sl - dx;
    });
    function endDrag(e) {
      if (!drag) return; var dx = e.clientX - drag.x; drag = null; gal.classList.remove('is-drag');
      go(Math.abs(dx) > 50 ? gi + (dx < 0 ? 1 : -1) : gi);
    }
    gal.addEventListener('pointerup', endDrag); gal.addEventListener('pointercancel', endDrag);
    document.addEventListener('keydown', function (e) {
      if (!active || gImgs.length < 2) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(gi + 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(gi - 1); }
    });
    window.addEventListener('resize', function () { if (active) { sync(); go(gi, true); } });
    function closeCard() { active = null; shade.classList.remove('is-on'); card.classList.remove('is-open'); P.forEach(function (q) { q.chip.classList.remove('is-on'); }); render(); }
    card.querySelector('.at-wcard__x').addEventListener('click', closeCard);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && active) closeCard(); });

    /* csoport váltó */
    root.querySelectorAll('[data-at-wgroup]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-at-wgroup]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        group = b.dataset.atWgroup; closeCard();
        P.forEach(function (p) { p.chip.hidden = !visible(p); });
        if (group === 'all' || group === 'world') zoomTo({ k: 1, x: 0, y: 0 }); else fit(P.filter(visible), null, 1);
      });
    });
    function visible(p) { return group === 'all' || p.group === group; }

    libs(root).then(function (world) {
      var d3 = window.d3, W = 1180, H = 560;
      var proj = d3.geoNaturalEarth1().fitExtent([[10, 10], [W - 10, H - 10]], { type: 'Sphere' });
      var path = d3.geoPath(proj);
      var svg = d3.select(host).append('svg').attr('viewBox', '0 0 ' + W + ' ' + H).attr('role', 'img').attr('aria-label', data.label || 'Világtérkép');
      var gz = svg.append('g');
      var countries = window.topojson.feature(world, world.objects.countries).features;
      var land = gz.selectAll('path').data(countries).enter().append('path').attr('class', 'at-wland').attr('d', path);
      function paintLand() {
        land.classed('is-hit', function (d) { return P.some(function (p) { return p.hl && visible(p) && d3.geoContains(d, [p.lon, p.lat]); }); });
      }
      var gp = svg.append('g');
      P.forEach(function (p) { p.xy = proj([p.lon, p.lat]); });

      function unit() { var w = svg.node().getBoundingClientRect().width || W; return Math.min(Math.max(W / w, 0.8), 3.2); }
      function scr(p) { return [p.xy[0] * T.k + T.x, p.xy[1] * T.k + T.y]; }

      /* fürtözés a képernyőn */
      function clusters(R) {
        var out = P.filter(visible).map(function (p) { var s = scr(p); return { x: s[0], y: s[1], m: [p] }; });
        var again = true;
        while (again) {
          again = false;
          for (var i = 0; i < out.length && !again; i++) for (var j = i + 1; j < out.length; j++) {
            var dx = out[i].x - out[j].x, dy = out[i].y - out[j].y;
            if (dx * dx + dy * dy < R * R) {
              var a = out[i], b = out[j], n = a.m.length + b.m.length;
              a.x = (a.x * a.m.length + b.x * b.m.length) / n; a.y = (a.y * a.m.length + b.y * b.m.length) / n;
              a.m = a.m.concat(b.m); out.splice(j, 1); again = true; break;
            }
          }
        }
        return out;
      }
      var MAXK = 60;
      render = function () {
        var u = unit(), R = 36 * u;
        var cl = clusters(R);
        gp.selectAll('*').remove();
        cl.forEach(function (c) {
          var lone = c.m.length === 1, stuck = !lone && T.k >= MAXK * 0.98;
          if (lone || stuck) {
            c.m.forEach(function (p, j) {
              var s = scr(p), ox = 0, oy = 0;
              if (stuck) { var a = (j / c.m.length) * Math.PI * 2 - Math.PI / 2; ox = Math.cos(a) * 34 * u; oy = Math.sin(a) * 34 * u; }
              var g = gp.append('g').attr('class', 'at-wpin' + (active === p ? ' is-on' : '')).attr('transform', 'translate(' + s[0] + ',' + s[1] + ')')
                .attr('tabindex', 0).attr('role', 'button').attr('aria-label', p.title)
                .on('click', function () { openCard(p); }).on('keydown', function (e) { if (e.key === 'Enter') openCard(p); });
              if (ox || oy) g.append('line').attr('x1', 0).attr('y1', 0).attr('x2', ox).attr('y2', oy);
              var q = g.append('g').attr('transform', 'translate(' + ox + ',' + oy + ')');
              q.append('circle').attr('class', 'ring').attr('r', 8 * u);
              q.append('circle').attr('class', 'dot').attr('r', 7 * u);
              var right = s[0] + ox < W - 120;
              q.append('text').attr('x', (right ? 12 : -12) * u).attr('y', 4 * u).attr('text-anchor', right ? 'start' : 'end').style('font-size', 12 * u + 'px').style('stroke-width', 3 * u + 'px').text(p.title);
            });
          } else {
            var g = gp.append('g').attr('class', 'at-wclu').attr('transform', 'translate(' + c.x + ',' + c.y + ')')
              .attr('tabindex', 0).attr('role', 'button').attr('aria-label', c.m.length + ' helyszín, nagyítás')
              .on('click', function () { fit(c.m); }).on('keydown', function (e) { if (e.key === 'Enter') fit(c.m); });
            g.append('circle').attr('class', 'halo').attr('r', 17 * u);
            g.append('circle').attr('class', 'big').attr('r', 16 * u);
            g.append('text').style('font-size', 13 * u + 'px').text(c.m.length);
            var lbl = commonLabel(c.m);
            if (lbl) g.append('text').attr('class', 'lbl').attr('y', 30 * u).style('font-size', 11 * u + 'px').style('stroke-width', 3 * u + 'px').text(lbl);
          }
        });
        /* feliratok ütközése: a később rajzolt, átfedő feliratot elrejtjük (a fürtök elsőbbséget kapnak) */
        var kept = [], texts = [].concat([].slice.call(gp.node().querySelectorAll('.at-wclu text.lbl')), [].slice.call(gp.node().querySelectorAll('.at-wpin text')));
        texts.forEach(function (t) {
          var r = t.getBoundingClientRect(); if (!r.width) return;
          var hit = kept.some(function (k) { return !(r.right < k.left || r.left > k.right || r.bottom < k.top || r.top > k.bottom); });
          var circles = [].slice.call(gp.node().querySelectorAll('.at-wclu .big'));
          if (!hit) hit = circles.some(function (c) { if (c.parentNode === t.parentNode) return false; var k = c.getBoundingClientRect(); return !(r.right < k.left || r.left > k.right || r.bottom < k.top || r.top > k.bottom); });
          if (hit) t.style.display = 'none'; else kept.push(r);
        });
        wrap.classList.toggle('is-zoomed', T.k > 1.01);
      };
      function commonLabel(m) {
        var g = m[0].region; for (var i = 1; i < m.length; i++) if (m[i].region !== g) return '';
        return g || '';
      }
      function zoomTo(t, cb) {
        var from = { k: T.k, x: T.x, y: T.y }, ip = d3.interpolateObject(from, t);
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        d3.select(gz.node()).interrupt().transition().duration(reduce ? 0 : 850).ease(d3.easeCubicInOut)
          .tween('z', function () { return function (e) { T = ip(e); gz.attr('transform', 'translate(' + T.x + ',' + T.y + ') scale(' + T.k + ')'); try { render(); } catch (err) {} }; })
          .on('end', function () { if (cb) cb(); })
          .on('interrupt', function () { /* megszakadt átmenet: ne ragadjon félúton */ setTimeout(function () { if (!d3.active(gz.node())) { T = t; gz.attr('transform', 'translate(' + T.x + ',' + T.y + ') scale(' + T.k + ')'); try { render(); } catch (err) {} } }, 0); });
      }
      fit = function (m, cb, minK) {
        if (!m.length) return;
        var xs = m.map(function (p) { return p.xy[0]; }), ys = m.map(function (p) { return p.xy[1]; });
        var x0 = Math.min.apply(0, xs), x1 = Math.max.apply(0, xs), y0 = Math.min.apply(0, ys), y1 = Math.max.apply(0, ys);
        var u = unit(), px = Math.min(90 * u, W * 0.22), py = Math.min(70 * u, H * 0.22);
        var k = Math.min(MAXK, (W - px * 2) / Math.max(x1 - x0, 1), (H - py * 2) / Math.max(y1 - y0, 1));
        k = Math.max(k, minK === undefined ? Math.min(T.k * 1.8, MAXK) : minK);
        if (k <= (minK === 1 ? 1.6 : 1.05)) { zoomTo({ k: 1, x: 0, y: 0 }, cb); return; }
        if (m.length === 1) k = Math.max(T.k, 6);
        var cx = (x0 + x1) / 2, cy = (y0 + y1) / 2;
        var tx = Math.min(0, Math.max(W - k * W, W / 2 - k * cx)), ty = Math.min(0, Math.max(H - k * H, H / 2 - k * cy));
        zoomTo({ k: k, x: tx, y: ty }, cb);
      };
      zoomToRef = zoomTo;
      paintLand(); render();
      root.querySelectorAll('[data-at-wgroup]').forEach(function (b) { b.addEventListener('click', paintLand); });
      root.querySelector('.at-wback').addEventListener('click', function () { closeCard(); zoomTo({ k: 1, x: 0, y: 0 }); });
      var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(render, 150); });
      root.classList.add('is-ready');
    }).catch(function () { host.innerHTML = '<p class="at-center" style="padding:3rem 0">A térkép most nem tölthető be.</p>'; });

    var render = function () {}, fit = function () {}, zoomToRef = null;
    function zoomTo(t) { if (zoomToRef) zoomToRef(t); }
    /* chip / kártya: addig nagyít, amíg a pont külön nem válik */
    function focusPlace(p) {
      if (!visible(p)) return;
      if (!p.xy) { openCard(p); return; }
      var near = P.filter(function (q) { return visible(q) && Math.abs(q.xy[0] - p.xy[0]) < 2 && Math.abs(q.xy[1] - p.xy[1]) < 2 && q !== p; });
      var others = P.filter(function (q) { return visible(q) && q !== p; });
      /* a legközelebbi szomszéd alapján elég nagyítás */
      var dmin = Infinity; others.forEach(function (q) { var dx = q.xy[0] - p.xy[0], dy = q.xy[1] - p.xy[1]; dmin = Math.min(dmin, Math.sqrt(dx * dx + dy * dy)); });
      var u = W_UNIT(), need = dmin === Infinity ? 1 : (36 * u) / Math.max(dmin, 0.01);
      var k = Math.min(60, Math.max(1, need));
      if (near.length) k = 60;
      if (k <= 1.01) { zoomTo({ k: 1, x: 0, y: 0 }); openCard(p); return; }
      zoomTo({ k: k, x: 1180 / 2 - k * p.xy[0], y: 560 / 2 - k * p.xy[1] });
      setTimeout(function () { openCard(p); }, 880);
    }
    function W_UNIT() { var s = host.querySelector('svg'); var w = s ? s.getBoundingClientRect().width : 1180; return Math.min(Math.max(1180 / (w || 1180), 0.8), 3.2); }
  }

  function boot() {
    var maps = document.querySelectorAll('[data-at-world]:not([data-at-init])');
    if (!maps.length) return;
    if (!('IntersectionObserver' in window)) { maps.forEach(init); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); init(e.target); } }); }, { rootMargin: '600px 0px' });
    maps.forEach(function (m) { io.observe(m); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
